const utl_pageId = document.querySelector("body").getAttribute("id");
const utl_setYear = () => (document.querySelector("#current-year").innerHTML = new Date().getFullYear());
const html = String.raw;

export { utl_pageId, utl_setYear, html };
